import * as React from "react";
import { Modal, notification } from "antd";
import { linksOf, request } from "../../../services/cpln";
import { Workload } from "../../../schema/types/workload/entity";

interface Props {
  workload: Workload;
  location: string;
  replica: string;
  onClose: any;
  onDone: any;
  visible: boolean;
}

export const CommandModal_ConfirmReplicaTermination: React.FC<Props> = ({
  workload,
  location,
  replica,
  onClose,
  onDone,
  visible,
}) => {
  const [isLoading, setIsLoading] = React.useState(false);

  async function handleConfirm() {
    setIsLoading(true);
    try {
      await request({
        method: "post",
        url: linksOf(workload).self + "/-command",
        body: {
          type: "stopReplica",
          spec: { replica, location },
        },
      });
      onDone();
      notification.success({
        message: "Success",
        description: `${workload.spec.type === "stateful" ? "Restarted" : "Stopped"} ${replica}`,
      });
    } catch (e) {
      let errorMessage = e?.response?.data?.message;
      if (!errorMessage) errorMessage = e.message;
      notification.warning({
        message: `Failed to ${workload.spec.type === "stateful" ? "restart" : "stop"} ${replica}`,
        description: errorMessage,
      });
    }
    setIsLoading(false);
  }

  // TODO can just be a confirm modal
  return (
    <Modal
      width={450}
      open={visible}
      title={`Are you sure you want to ${workload.spec.type === "stateful" ? "restart" : "stop"} replica?`}
      okText={`Confirm`}
      cancelButtonProps={{ disabled: isLoading }}
      okButtonProps={{ disabled: isLoading, loading: isLoading }}
      onCancel={onClose}
      onOk={handleConfirm}
      maskClosable={false}
      destroyOnHidden
    />
  );
};
